import { BadgeColor } from '@components/Badge';

import { EventStatus } from './common';

export const EventStatusKr: Record<EventStatus, string> = {
    WAIT: '대기',
    ACTIVE: '진행중',
    CLOSED: '진행 종료',
};

export const EventStatusBadgeColor: Record<EventStatus, BadgeColor> = {
    WAIT: 'gray',
    ACTIVE: 'blue',
    CLOSED: 'gray',
};
